import { useAuth } from "@ozpanel/ui";
import type { paths } from "@ozpanel/shared";

// modules.ts — reads the live module registry (GET /ozpanel/modules, super_admin only).
// Not generated from the typed client's schema types directly (openapi-fetch's inferred
// response type for this route collapses to a loose shape since the Go handler returns
// module.Manifest inline) — hand-typed here against the real struct
// (internal/module/module.go's Manifest, confirmed field-for-field), matching how the rest
// of this codebase hand-writes a type once and cites where it came from rather than fighting
// a generator for a shape it cannot express well.

export interface ModuleManifest {
  name: string;
  version: string;
  title: string;
  description: string;
  tiers: string[] | null;
  owner?: string;
  unit?: string;
  /** Several backing units (JuiceFS: one per volume) — each gets service state, usage and controls. */
  units?: string[];
  web_ui?: string;
  realtime_roles?: string[];
  category?: string;
}

export interface ModuleRow {
  manifest: ModuleManifest;
  health: string;
}

export interface ModulesResponse {
  items: ModuleRow[];
  total: number;
}

type Paths = paths;
// Referenced so a future route-shape change in the committed OpenAPI snapshot shows up as
// an unused-import/typecheck concern here, prompting a re-check of ModuleManifest above
// against the real Go struct rather than letting the two silently drift. The spec's own path
// keys carry the /api/v1 prefix (server-relative, not apiFetch-relative — apiFetch prepends
// the prefix itself, so callers below still pass the bare "/ozpanel/modules").
export type _EnsureRouteExists = Paths["/api/v1/ozpanel/modules"];

export function useModules() {
  const { client } = useAuth();
  return {
    list: () => client.apiFetch<ModulesResponse>("/ozpanel/modules"),
  };
}
